import React from "react";
import user from "../../assets/user.jpeg";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { CiLogout } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/store/userSlice";
import { toast } from "react-toastify";
import { userProfile } from "../../data/links";
const Sidebar = ({ close, isMobile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout({ scope: "customer" }));
    toast.success("You have logged out successfully!", { autoClose: 3000 });
    navigate("/");
  };
  return (
    // <div className="hidden md:flex flex-[0.3] shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-[2rem] px-[2rem]">
    //   <hr />

    <div className="w-full sm:w-[260px] md:w-[280px] lg:w-[300px]">
      <div className="my-4 sm:my-6 flex flex-col gap-2">
        {userProfile.map((link, index) => {
          const isActive =
            location.pathname === link.link ||
            (!userProfile.some((l) => l.link === location.pathname) &&
              link.link === "/user/profile");

          return (
            <Link
              key={index}
              onClick={() => {
                if (isMobile) close();
              }}
              to={link.link}
              className={`
            group flex items-center gap-3 w-full px-4 py-3 
            rounded-xl text-[15px] sm:text-[16px] font-medium
            transition-all duration-300 ease-in-out

            ${
              isActive
                ? "bg-black text-white shadow-md"
                : "text-gray-500 hover:bg-gray-100 hover:text-black"
            }
          `}
            >
              <span
                className={`
            text-[20px] transition-transform duration-300 
            ${isActive ? "scale-110" : "group-hover:scale-110"}
          `}
              >
                {link.icon}
              </span>

              <span className="flex-1">{link.title}</span>

              {/* Active indicator */}
              {isActive && (
                <span className="w-2 h-2 rounded-full bg-white"></span>
              )}
            </Link>
          );
        })}

        {/* Divider */}
        <div className="my-3 border-t border-gray-200"></div>

        {/* Logout */}
        <button
          onClick={() => {
            handleLogout();
            if (isMobile) close();
          }}
          className="
        group flex items-center gap-3 w-full px-4 py-3 
        rounded-xl text-[15px] sm:text-[16px] font-medium
        text-red-500 hover:bg-red-50
        transition-all duration-300 ease-in-out
      "
        >
          <span className="text-[20px] group-hover:scale-110 transition">
            <CiLogout />
          </span>
          Logout
        </button>
      </div>
    </div>
    //   <hr />
    // </div>
  );
};

export default Sidebar;
